import React from 'react';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { Projects } from './Projects';

export const ProjectsContainer = () => {

  return (
    <QueryProvider
      defaultVariables={{}}
      cacheKey="projects-landing-page"
    >
      <Projects />
    </QueryProvider>
  );
};

ProjectsContainer.dataModel = extend(Projects);

ProjectsContainer.propTypes = {
};

ProjectsContainer.defaultProps = {
};